import React, { PropTypes } from 'react';
import {
  STREAM_EVENT_LIVE,
  VIDEO_ON_DEMAND
} from '../../../../api/stream/LiveStadiumStreamEvent';
import { SpeedDial, SpeedDialItem } from '../../../SpeedDial';
import { Tabs, Tab } from 'material-ui/Tabs';
import LoggedAppBar from '../../../LoggedLayout/LoggedAppBar';
import IconStreamCircle from '../../../Icons/IconStreamCircle';
import IconVoD from '../../../Icons/IconVoD';

class StreamRoot extends React.Component {
  static propTypes = {
    goToLive: PropTypes.func.isRequired,
    children: PropTypes.node
  };

  static contextTypes = {
    muiTheme: React.PropTypes.object
  };

  defaultProps = {
    displayStatus: false
  };

  state = {
    openSpeedDial: false
  };

  headerTitle = 'Streams';

  _toggleSpeedDial() {
    let { openSpeedDial } = this.state;
    openSpeedDial = !openSpeedDial;
    this.setState({ openSpeedDial });
  }

  initialSelectedTab() {
    switch (this.props.location.pathname.split('/')[2]) {
      case STREAM_EVENT_LIVE:
        return 0;
      case VIDEO_ON_DEMAND:
        return 1;
      default:
        return 0;
    }
  }

  render() {
    const { children, params } = this.props;
    const { category_id } = params
    let {
      palette: { labelColor }
    } = this.context.muiTheme;
    const selectedTab = this.initialSelectedTab()
    return (
      <div>
        <LoggedAppBar
          title={this.headerTitle}
          isStatic={true}
          childrenHeight={ selectedTab === 0 ? -16 : 48 }
        >
          <Tabs initialSelectedIndex={ selectedTab }>
            <Tab
              style={{ color: labelColor }}
              label="LIVE STREAMS"
              onClick={this.props.goToLive}
              value={STREAM_EVENT_LIVE}
            />
            <Tab
              style={{ color: labelColor }}
              label="VIDEO ON DEMAND"
              onClick={this.props.gotoVoD}
              value={VIDEO_ON_DEMAND}
            />
          </Tabs>
        </LoggedAppBar>
        {children}
        <SpeedDial
          open={this.state.openSpeedDial}
          onClick={() => this._toggleSpeedDial()}
          direction="up"
          style={{ position: 'fixed', right: 25, bottom: 25 }}
        >
          <SpeedDialItem
            label="ADD NEW STREAM"
            secondary={true}
            icon={<IconStreamCircle color="white" />}
            onClick={this.props.addStream}
          />
          <SpeedDialItem
            label="ADD VIDEO ON DEMAND"
            secondary={true}
            icon={<IconVoD color="white" />}
            onClick={() => this.props.addVoD(category_id)}
          />
        </SpeedDial>
      </div>
    );
  }
}

export default StreamRoot;



// WEBPACK FOOTER //
// ./src/components/Stream/LiveStream/StreamRoot/StreamRoot.jsx